var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth_wrapper"},[_c('LoginToolbar'),_c('div',{staticClass:"login-page justify-center align-center d-flex"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }